import { render, staticRenderFns } from "./DisplayAction.vue?vue&type=template&id=b632fbf6&"
import script from "./DisplayAction.vue?vue&type=script&lang=js&"
export * from "./DisplayAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports